module.exports = __webpack_public_path__ + "img/dcu30-5.39d110e3.png";